import { Col } from "reactstrap";
import { RegisterForm } from "../Common/RegisterForm";

const RegisterSimpleContainer = () => {
  return (
    <Col sm="12" className="p-0">
      <div className="login-card login-dark">
        <RegisterForm />
      </div>
    </Col>
  );
};

export default RegisterSimpleContainer;
